<script lang="ts">
import { ElTag } from "element-plus";

export enum TagVariant {
  Gray,
  Black,
  Green,
}

export default {
  components: {
    ElTag,
  },
  props: {
    variant: {
      type: Number as PropType<TagVariant>,
      default: () => TagVariant.Gray,
    },
  },
  setup(props, { attrs }) {
    if (props.variant === TagVariant.Black) {
      throw new Error("DEV: Black tag variant not implemented yet.");
    }

    const cssClasses = computed(() => {
      return {
        "el-tag": true,
        "colectio-tag": true,
        "colectio-tag--gray": props.variant === TagVariant.Gray,
        "colectio-tag--green": props.variant === TagVariant.Green,
        "colectio-tag--black": props.variant === TagVariant.Black,
      };
    });

    return {
      attrs,
      cssClasses,
    };
  },
};
</script>

<template>
  <ElTag v-bind="attrs" :class="cssClasses">
    <slot></slot>
  </ElTag>
</template>

<style lang="scss">
.el-tag.colectio-tag {
  --verticalPadding: calc(var(--spacing1x) / 2);
  --horizontalPadding: calc(var(--spacing3x) / 2);

  padding: var(--verticalPadding) var(--horizontalPadding);
  text-transform: uppercase;
  font-size: 11px;
  border-radius: var(--radius4x);
  border: 0;
  height: 22px;
  line-height: 0.5;

  &.colectio-tag--gray {
    color: var(--white);
    background-color: var(--grayTransparent500);
  }
  &.colectio-tag--green {
    color: var(--white);
    background-color: var(--green500);
  }
  &.colectio-tag--black {
    // Not implemented yet
  }
}
</style>
